import React from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import PageWithLayout from 'src/components/layout/PageWithLayout';
import { AIModelTable } from 'src/features/ai_model/components/AIModelTable';
import { RootState } from 'src/store';

const AIModelPage: React.FC = () => {
	const { siteSlug } = useParams<{
		siteSlug: string;
	}>();

	const siteDetails = useSelector(
		(state: RootState) => state.site.siteDetails,
	);

	const breadcrumbs = [
		{
			label: siteDetails?.name || 'Site Details',
			href: `/site/${siteSlug}`,
		},
		{ label: 'AI Models' },
	];

	return (
		<PageWithLayout breadcrumbs={breadcrumbs}>
			<AIModelTable />
		</PageWithLayout>
	);
};

export default AIModelPage;
